import classNames from "classnames";
import React from "react";

import * as css from "@/assets/styles/elements/PageLoader.module.scss";

import LogoLight from "../icons/LogoLight";

const Spinner = () => {
    return (
        <div className={classNames('d-inline-block text-white w-12 md:w-16 h-12 md:h-16 transition-sm', css.loadingSpinner)}>
            <LogoLight />
        </div>
    );
};

export default Spinner;
